import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { MoreActionsButton } from '../../../MoreActionsButton'

import { getEmailReplyFormMobileMoreActions } from './EmailReplyFormMobileMoreActions.utils'

import * as styles from './EmailReplyFormMobileMoreActions.module.css'

function EmailReplyFormMobileMoreActions({
  attachActionOptions,
  disabled,
  onAttachAction,
  onMakeFormFullScreen,
  onMobileOpenFileAttach,
  onRemoveDraft,
}) {
  const { t } = useTranslation()

  const actions = getEmailReplyFormMobileMoreActions({
    attachActionOptions,
    disabled,
    dividerClassName: styles.divider,
    t,
    onAttachAction,
    onMakeFormFullScreen,
    onMobileOpenFileAttach,
    onRemoveDraft,
  })

  return (
    <MoreActionsButton
      actions={actions}
      disabled={disabled}
      text={t('Common.More')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default EmailReplyFormMobileMoreActions
